import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="event-form"
export default class extends Controller {
  static targets = ["link", "address", "radio-online", "radio-offline", "recurrence", "participantLimit"]

  toggleLinkAddress(event) {
    if (event.target.value === "online") {
      this.linkTarget.style.display = "block"
      this.addressTarget.style.display = "none"
    } else if (event.target.value === "offline") {
      this.linkTarget.style.display = "none"
      this.addressTarget.style.display = "block"
    }
  }

  toggleRecurrence(event) {
    if (event.target.checked) {
      this.recurrenceTarget.style.display = "block"
    } else {
      this.recurrenceTarget.style.display = "none"
    }
  }

  toggleParticipantLimit(event) {
    if (event.target.checked) {
      this.participantLimitTarget.style.display = "block"
    } else {
      this.participantLimitTarget.style.display = "none"
    }
  }
}
